import { Honeybadger } from '@honeybadger-io/react';

import { seedQueuedExport } from 'components/practice/Export/ExportDockCard/lib/upsertExportJob';

import { openLoadingTab } from './loadingTab';
import { deliverBlob, printBlob } from './blobDelivery';

export const streamPdf = async ({
  request,
  title,
  view,
  print,
  context,
  viewTab: preOpenedTab
}) => {
  const viewTab = view && !print ? preOpenedTab || openLoadingTab() : null;
  const disposition = view || print ? 'inline' : 'attachment';

  try {
    const result = await request(disposition);

    if (result && !(result instanceof Blob) && result.status === 'queued') {
      viewTab?.close();
      seedQueuedExport(result.exportJobId, 'invoice');
      return true;
    }

    if (!(result instanceof Blob) || result.type !== 'application/pdf') {
      viewTab?.close();
      return false;
    }

    if (print) {
      printBlob(result, title);
    } else {
      deliverBlob(result, { title, viewTab });
    }
    return true;
  } catch (error) {
    viewTab?.close();
    Honeybadger.notify(error, {
      name: '[error]streamPdf',
      context: { title, ...context },
      tags: 'error,frontend,pdf'
    });
    return false;
  }
};
